import React from 'react';
import HealthFilesGrid from './HealthFilesGrid';

export default function HealthExploreView(props) {
  return (
    <HealthFilesGrid
      {...props}
      emptyMessage="No files match your filters. Add a file to get started."
    />
  );
}
